import { Component, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { notificationIcons } from 'src/app/helpers/IndexingArrays';
import { Notification } from 'src/app/models/Notification';
import { NotificationsService } from 'src/app/services/notifications.service';
import { RouterService } from 'src/app/services/router-service.service';

@Component({
	selector: 'app-notifications-panel',
	templateUrl: './notifications-panel.component.html',
	styleUrls: ['./notifications-panel.component.scss'],
})
export class NotificationsPanelComponent {

	@Input() notifications? : Notification[];
	@Output() eeOneDown = new EventEmitter<void>();
	@Output() eeAllCleared = new EventEmitter<void>();
	notificationIcons = notificationIcons();
	@ViewChild("wrapper") wrapper! : ElementRef;

	constructor(public routerService:RouterService,
				private notificationsService:NotificationsService) {}

	onNotificationClick(index:number) {
		this.notificationsService.notificationAction(this.notifications![index])
		this.notificationsService.markAsRead(this.notifications![index].id).subscribe({
			next: ()=> {
				this.eeOneDown.emit();
				this.notifications!.splice(index, 1);
			}
		});
	}

	clearAllNotifications() {
		this.notificationsService.markAsRead("all").subscribe({
			next: ()=> {
				this.notifications = [];
				this.eeAllCleared.emit();
			}
		});
	}

}
